import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { opacityFadeIn } from '@hiptraveler/animations';
import { ListView } from '../common';

@Component({
  selector: 'included',
  templateUrl: './included.component.html',
  styleUrls: ['./included.component.scss'],
  animations: [ opacityFadeIn() ]
})
export class IncludedComponent extends ListView implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public form: FormGroup
  ) {
    super()
  }

  ngOnInit(): void {
    this.items = (this.form.get('inclusions') as FormArray).value;
  }

  get formArray(): FormArray {
    return this.form.get('inclusions') as FormArray;
  }

}
